import React from "react";
// import { Link } from "react-router-dom";
// import ca_bg from '../assets/img/CA_SVG.svg';
// import logo_sm from '../assets/img/financeLogoF.png';

import Navbar from "../components/Navbars/AuthNavbar.js";
import Footer from "../components/Footers/Footer";
import Button from "../components/Button/Button";
// import Expertise from '../components/HomepageComponents/Expertise';
import me from "../assets/img/me.png";
// import Carousel from '../components/HomepageComponents/Carousel';

function Hompage() {
  return (
    <>
      <Navbar />
      <main
        className="bg-gray-50 w-full pt-28 lg:pt-10 "
        // style={{ marginTop: "20vw" }}
      >
        {/* <Carousel /> */}
        <div className="relative pt-0 bg-gray-50 pb-0 flex content-center items-center justify-center min-h-screen-75 flex-col lg:flex-row">
          <div
            className="relative  lg:absolute  mr-2 top-10 lg:right-20 w-1/2 md:w-1/3 mx-auto lg:min-h-screen bg-center bg-contain bg-no-repeat"
            style={{
              backgroundImage: `url( ${me})`,
            }}
          >
            <span
              // id="blackOverlay"
              className="w-full h-full absolute opacity-75 bg-black"
            ></span>
          </div>
          <div className="w-full relative mx-auto px-10">
            <div className="items-center md:flex md:flex-wrap">
              <div className="w-full lg:w-9/12 min-h-screen items-center flex m-auto lg:ml-0 text-center  lg:text-left">
                <div className="w-full md:px-10 lg:w-10/12 p-5 py-10 bg-blue-900 shadow-lg rounded-lg">
                  {/* <img className='inline-block w-2/12' src={logo_sm} /> */}
                  <h1 className=" inline-block text-gray-50 font-semibold text-5xl my-2">
                    Hey, I am Simranjeet Singh
                  </h1>
                  <h4 className="text-gray-50 font-semibold text-xl">
                    Fullstack Developer | ReactJs | NodeJs | MERN Stack | Python
                    | DRF
                  </h4>
                  <div className=" p-1 my-5 lg:w-5/12 lg:mr-40 text-gray-900 bg-gray-50 shadow-2xl rounded-lg"></div>
                  <p className="mt-4 text-gray-100 text-sm font-bold">
                    Hi, I'm Simranjeet Singh, a seasoned software engineer with
                    a passion for building impactful software solutions using
                    the latest technologies. With years of experience working
                    with product and service-based companies, I have developed a
                    deep understanding of frontend technologies such as React
                    and backend technologies such as Django, Node.js, and Java
                    Spring Boot. <br />
                    Throughout my career, I have had the privilege of working on
                    a variety of projects, from building products from scratch
                    to optimizing existing infrastructure. I am committed to
                    delivering high-quality, scalable, and secure solutions that
                    exceed business expectations and meet the needs of
                    end-users.
                    <br />
                    Whether it's designing and implementing RESTful APIs,
                    optimizing front-end interfaces for maximum performance, or
                    mentoring junior developers, I am passionate about tackling
                    complex challenges and delivering impactful results. I am
                    always striving to stay at the forefront of the
                    ever-evolving software industry and committed to continuous
                    learning and growth.
                    <br />
                    If you're looking for a results-driven, hands-on leader with
                    a commitment to delivering value and driving success, I'd
                    love to hear from you. Let's work together to build
                    something great!
                  </p>
                  <div className=" justify-center lg:justify-start flex items-center lg:items-start my-5 font-bold text-sm">
                    {/* <Button to="#projects" white>
                      Projects
                    </Button> */}
                    <Button to="https://linktr.ee/thesimranjeet" white>
                      Resume
                    </Button>
                  </div>
                  {/* <div className=' p-1 text-gray-900 bg-gray-50 shadow-2xl rounded-lg'>

                  </div> */}
                </div>
              </div>
              {/* <div className="lg:w-full lg:lg:w-6/12 lg:h-screen"></div> */}
            </div>
          </div>
        </div>
        {/* <svg xmlns="http://www.w3.org/2000/svg" className='absolute fill-current text-yellow-400' viewBox="0 0 1440 320">
          <path fill-opacity="1" d="M0,128L0,224L96,224L96,32L192,32L192,64L288,64L288,96L384,96L384,128L480,128L480,224L576,224L576,128L672,128L672,192L768,192L768,320L864,320L864,288L960,288L960,192L1056,192L1056,64L1152,64L1152,32L1248,32L1248,96L1344,96L1344,224L1440,224L1440,0L1344,0L1344,0L1248,0L1248,0L1152,0L1152,0L1056,0L1056,0L960,0L960,0L864,0L864,0L768,0L768,0L672,0L672,0L576,0L576,0L480,0L480,0L384,0L384,0L288,0L288,0L192,0L192,0L96,0L96,0L0,0L0,0Z"></path>
        </svg> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="absolute fill-current text-gray-50"
          viewBox="0 0 1440 320"
        >
          <path
            fill-opacity="1"
            d="M0,256L48,250.7C96,245,192,235,288,218.7C384,203,480,181,576,176C672,171,768,181,864,208C960,235,1056,277,1152,298.7C1248,320,1344,320,1392,320L1440,320L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          ></path>
        </svg>
        {/* <img
          alt='...'
          src={me}
          className='w-full align-middle rounded-t-lg absolute fill-current text-gray-50'
        /> */}
        {/* <section
          className="pb-20 pt-32 sm:pt-40 md:pt-56 lg:pt-80 bg-blue-900"
          id="projects"
        >
          <div className="mx-auto px-10">
            <div className="flex flex-wrap">
              <div className=" pt-6 w-full md:w-4/12 transform transition duration-500 md:hover:scale-110  px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-gray-50 w-full mb-8 shadow-lg md:hover:shadow-2xl rounded-lg">
                  <div className=" flex-auto">
                    <img
                      alt="..."
                      src="https://github.com/thesimranjeet/ecommerce_mern/raw/main/uploads/Screenshot.png"
                      className="w-full align-middle rounded-t-lg"
                    />

                    <h6 className="text-xl px-4 py-5 font-semibold">
                      Ecommerce App
                    </h6>
                    <div className="mb-5">
                      <Button to="https://mernshopp.herokuapp.com/">
                        Live Demo <i className="fas fa-rocket"></i>
                      </Button>
                      <Button to="https://github.com/thesimranjeet/ecommerce_mern">
                        Github <i className="fab fa-github"></i>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" pt-6 w-full md:w-4/12 transform transition duration-500 md:hover:scale-110  px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-gray-50 w-full mb-8 shadow-lg md:hover:shadow-2xl rounded-lg">
                  <div className=" flex-auto">
                    <img
                      alt="..."
                      src="https://github.com/thesimranjeet/nextjs-wrld/raw/main/src/assets/homepage.png"
                      className="w-full align-middle rounded-t-lg"
                    />

                    <h6 className="text-xl px-4 py-5 font-semibold">
                      NextJs app
                    </h6>
                    <div className="mb-5">
                      <Button to="https://wrld.vercel.app/">
                        Live Demo <i className="fas fa-rocket"></i>
                      </Button>
                      <Button to="https://github.com/thesimranjeet/nextjs-wrld">
                        Github <i className="fab fa-github"></i>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" pt-6 w-full md:w-4/12 transform transition duration-500 md:hover:scale-110  px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-gray-50 w-full mb-8 shadow-lg md:hover:shadow-2xl rounded-lg">
                  <div className=" flex-auto">
                    <img
                      alt="..."
                      src="https://github.com/thesimranjeet/url-shortener/raw/main/uploads/Screenshot.png"
                      className="w-full align-middle rounded-t-lg"
                    />

                    <h6 className="text-xl px-4 py-5 font-semibold">
                      Url Shortner App
                    </h6>
                    <div className="mb-5">
                      <Button to="https://urlshortnerappp.herokuapp.com">
                        Live Demo <i className="fas fa-rocket"></i>
                      </Button>
                      <Button to="https://github.com/thesimranjeet/url-shortener">
                        Github <i className="fab fa-github"></i>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          className="z-10 absolute fill-current text-blue-900"
          viewBox="0 0 1440 320"
        >
          <path
            fill-opacity="1"
            d="M0,32L48,37.3C96,43,192,53,288,53.3C384,53,480,43,576,74.7C672,107,768,181,864,186.7C960,192,1056,128,1152,85.3C1248,43,1344,21,1392,10.7L1440,0L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          ></path>
        </svg> */}

        {/* <Expertise></Expertise> */}

        {/* <section className="relative pt-60 py-20">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
            style={{ transform: "translateZ(0)" }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className=' relative fill-current text-blue-900' viewBox="0 0 1440 320">
              <path fill-opacity="1" d="M0,32L48,37.3C96,43,192,53,288,53.3C384,53,480,43,576,74.7C672,107,768,181,864,186.7C960,192,1056,128,1152,85.3C1248,43,1344,21,1392,10.7L1440,0L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
            </svg>
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-white fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>

          <div className="container mx-auto px-4">
            <div className="items-center flex flex-wrap">
              <div className="w-full md:w-4/12 ml-auto mr-auto px-4">
                <img
                  alt="..."
                  className="max-w-full rounded-lg shadow-lg"
                  src="https://images.unsplash.com/photo-1555212697-194d092e3b8f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80"
                />
              </div>
              <div className="w-full md:w-5/12 ml-auto mr-auto px-4">
                <div className="md:pr-12">
                  <div className="text-blue-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-blue-300">
                    <i className="fas fa-rocket text-xl"></i>
                  </div>
                  <h3 className="text-3xl font-semibold">A growing company</h3>
                  <p className="mt-4 text-lg leading-relaxed text-gray-600">
                    The extension comes with three pre-built pages to help you
                    get started faster. You can change the text and images and
                    you're good to go.
                  </p>
                  <ul className="list-none mt-6">
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blue-600 bg-blue-200 mr-3">
                            <i className="fas fa-fingerprint"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-gray-600">
                            Carefully crafted components
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blue-600 bg-blue-200 mr-3">
                            <i className="fab fa-html5"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-gray-600">
                            Amazing page examples
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <div>
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blue-600 bg-blue-200 mr-3">
                            <i className="far fa-paper-plane"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="text-gray-600">Dynamic components</h4>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pt-20 pb-48">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-center text-center mb-24">
              <div className="w-full lg:w-6/12 px-4">
                <h2 className="text-4xl font-semibold">Here are our heroes</h2>
                <p className="text-lg leading-relaxed m-4 text-gray-600">
                  According to the National Oceanic and Atmospheric
                  Administration, Ted, Scambos, NSIDClead scentist, puts the
                  potentially record maximum.
                </p>
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4">
                <div className="px-6">
                  <img
                    alt="..."
                    src={require("../assets/img/team-1-800x800.jpg")}
                    className="shadow-lg rounded-full mx-auto max-w-120-px"
                  />
                  <div className="pt-6 text-center">
                    <h5 className="text-xl font-bold">Ryan Tompson</h5>
                    <p className="mt-1 text-sm text-gray-500 uppercase font-semibold">
                      Web Developer
                    </p>
                    <div className="mt-6">
                      <button
                        className="bg-blue-400 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-twitter"></i>
                      </button>
                      <button
                        className="bg-blue-600 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </button>
                      <button
                        className="bg-pink-500 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-dribbble"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4">
                <div className="px-6">
                  <img
                    alt="..."
                    src={require("../assets/img/team-2-800x800.jpg")}
                    className="shadow-lg rounded-full mx-auto max-w-120-px"
                  />
                  <div className="pt-6 text-center">
                    <h5 className="text-xl font-bold">Romina Hadid</h5>
                    <p className="mt-1 text-sm text-gray-500 uppercase font-semibold">
                      Marketing Specialist
                    </p>
                    <div className="mt-6">
                      <button
                        className="bg-red-600 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-google"></i>
                      </button>
                      <button
                        className="bg-blue-600 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4">
                <div className="px-6">
                  <img
                    alt="..."
                    src={require("../assets/img/team-3-800x800.jpg")}
                    className="shadow-lg rounded-full mx-auto max-w-120-px"
                  />
                  <div className="pt-6 text-center">
                    <h5 className="text-xl font-bold">Alexa Smith</h5>
                    <p className="mt-1 text-sm text-gray-500 uppercase font-semibold">
                      UI/UX Designer
                    </p>
                    <div className="mt-6">
                      <button
                        className="bg-red-600 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-google"></i>
                      </button>
                      <button
                        className="bg-blue-400 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-twitter"></i>
                      </button>
                      <button
                        className="bg-gray-800 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-instagram"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4">
                <div className="px-6">
                  <img
                    alt="..."
                    src={require("../assets/img/team-4-470x470.png")}
                    className="shadow-lg rounded-full mx-auto max-w-120-px"
                  />
                  <div className="pt-6 text-center">
                    <h5 className="text-xl font-bold">Jenna Kardi</h5>
                    <p className="mt-1 text-sm text-gray-500 uppercase font-semibold">
                      Founder and CEO
                    </p>
                    <div className="mt-6">
                      <button
                        className="bg-pink-500 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-dribbble"></i>
                      </button>
                      <button
                        className="bg-red-600 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-google"></i>
                      </button>
                      <button
                        className="bg-blue-400 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-twitter"></i>
                      </button>
                      <button
                        className="bg-gray-800 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                      >
                        <i className="fab fa-instagram"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
      </main>
      <Footer />
    </>
  );
}

export default Hompage;
